import BasicResource from '@/api/resource';

class EmailTemplatesResource extends BasicResource {

    constructor () {
        super('email-templates');
    }

    recipients (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/email-templates/recipient-placeholders',
            params,
        });
    }

    placeholders (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/email-templates/placeholders',
            params,
        });
    }

    fetchPreview (payload) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/email-templates/preview',
            data: payload,
        });
    }

    layouts (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/email-templates/layouts',
            params,
        });
    }

    layoutsDict (params) {
        return this.client.request({
            method: 'get',
            path: '/upyield/v1/email-templates/layouts/dict',
            params,
        });
    }

    addLayout (payload) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/email-templates/layouts',
            data: payload,
        });
    }

    getLayout (id, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/email-templates/layouts/${id}`,
            params,
        });
    }

    updateLayout (id, payload) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/email-templates/layouts/${id}`,
            data: payload,
        });
    }

    deleteLayout (id) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/email-templates/layouts/${id}`,
        });
    }

    layoutPreview (payload) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/email-templates/layouts/preview',
            data: payload,
        });
    }

    layoutPreviewId (id, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/email-templates/layouts/${id}/preview`,
            params,
        });
    }

    setLayoutDefault (id) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/email-templates/layouts/${id}/default`,
        });
    }
}

export default new EmailTemplatesResource;
